<template>
  <div class="box-area-ges">
    <!-- Seleccion -->
    <template v-if="show">
      <div>
        Selecciona un SVE en la lista de la izquierda para ver sus áreas relacionadas
      </div>
    </template>
    <!-- end -->

    <!-- Tables -->
    <template v-else>
      <div class="col-12">
        <b-overlay
            :show="processing"
            variant="transparent"
            opacity="1"
            blur="2px"
            spinner-type="grow"
            spinner-small>
          <div class="row">
            <div class="col-6">
              <!-- Table Operative -->
              <b-table :items="getGESOperative.data"
                       :fields="fieldsOperative"
                       show-empty
                       empty-text="Sin datos para mostrar."
                       :busy="processingChangePageOperative"
                       hover>
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                    <strong> Cargando...</strong>
                  </div>
                </template>
              </b-table>
              <!-- End -->
              <!-- Pagination -->
              <pagination :data="getGESOperative"
                          :limit="5"
                          @pagination-change-page="changePageGESOperative" />
              <!-- end -->
            </div>
            <div class="col-6">
              <!-- Table Administrative -->
              <b-table :items="getGESAdministrative.data"
                       :fields="fieldsAdministrative"
                       show-empty
                       empty-text="Sin datos para mostrar."
                       :busy="processingChangePageAdministrative"
                       hover>
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                    <strong> Cargando...</strong>
                  </div>
                </template>
              </b-table>
              <!-- End -->
              <!-- Pagination -->
              <pagination :data="getGESAdministrative"
                          :limit="5"
                          @pagination-change-page="changePageGESOAdministrative" />
              <!-- end -->
            </div>
          </div>
        </b-overlay>
      </div>
    </template>
    <!-- end -->
  </div>
</template>

<script>
import controller from './controller'
const { component } = controller()
export default component
</script>

<style lang="scss" scoped src="./style.scss"/>